import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { IoClose } from 'react-icons/io5';
import './modals.css';

const PricingModal = ({ isOpen, toggle }) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return localStorage.getItem('Language') || 'EN';
    });

    useEffect(() => {
        setSelectedLanguage(localStorage.getItem('Language') || 'EN');
    }, [isOpen]);


    return (
        <Modal isOpen={isOpen} toggle={toggle} className="pricing-modal-overlay" centered>
            <ModalBody className="pricing-modal-body" style={{ position: 'relative', padding: 0, backgroundColor: 'transparent', border: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
                {/* Image Viewer with overlay close button */}
                <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                    <img
                        src="/documents/F26 Sala za sastanke_Cenovnik.png"
                        alt={selectedLanguage === 'EN' ? 'Conference Room Pricing' : 'Cenovnik sale za sastanke'}
                        style={{
                            maxWidth: '90vw',
                            maxHeight: '80vh',
                            objectFit: 'contain',
                            display: 'block',
                            borderRadius: '8px'
                        }}
                    />
                    
                    {/* Close button overlaying the image */}
                    <button 
                        type="button" 
                        className="btn-close" 
                        onClick={toggle} 
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            zIndex: 1000
                        }}
                    />
                </div>
            </ModalBody>
        </Modal>
    );
};

export default PricingModal;